// extracted by mini-css-extract-plugin
module.exports = {"bb-breadcrumbs":"bb-breadcrumbs__t875T"};